// Faz BO (2026-05-10) — Topbar (mevcut Layout topbar'ından çıkarıldı)
// Faz BP'de redesign edilecek (sayfa başlığı + breadcrumb + Yeni ▾ dropdown +
// kullanıcı menüsü). Şimdilik mevcut davranış korunarak yeni layout shell'e taşındı.
import React from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Toolbar, Box, Typography, Avatar, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import NotificationBell from "../NotificationBell";
import { useThemeMode } from "../../theme";

export default function Topbar({ onMobileMenuClick }) {
  const navigate = useNavigate();
  const { mode, toggle: toggleTheme } = useThemeMode();
  const logout = () => { localStorage.clear(); navigate("/login"); };

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{
        bgcolor: "background.paper",
        color: "text.primary",
        borderBottom: 1,
        borderColor: "divider",
        zIndex: (t) => t.zIndex.drawer - 1,
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 56, md: 64 } }}>
        <IconButton
          aria-label="Menüyü aç"
          onClick={onMobileMenuClick}
          sx={{ mr: 1, display: { xs: "inline-flex", md: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700, fontSize: 16 }}>
          Miksan Plastik Admin
        </Typography>

        {/* Cmd+K hint */}
        <Box
          onClick={() => window.dispatchEvent(new KeyboardEvent("keydown", { key: "k", ctrlKey: true }))}
          sx={{
            mr: 1.5,
            px: 1.5, py: 0.5,
            border: 1, borderColor: "divider", borderRadius: 1,
            fontSize: 12, color: "text.secondary",
            cursor: "pointer",
            display: { xs: "none", sm: "inline-flex" },
            alignItems: "center",
            gap: 0.5,
            "&:hover": { bgcolor: "action.hover" },
          }}
          title="Ctrl+K"
          aria-label="Hızlı arama (Ctrl+K)"
        >
          🔍 Hızlı Arama
          <Box component="span" sx={{ fontSize: 10, opacity: 0.7, ml: 0.5 }}>Ctrl+K</Box>
        </Box>

        <NotificationBell />

        <IconButton
          onClick={toggleTheme}
          aria-label={mode === "dark" ? "Açık temaya geç" : "Koyu temaya geç"}
          title={mode === "dark" ? "Açık tema" : "Koyu tema"}
        >
          {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>

        <Avatar sx={{ bgcolor: "primary.main", ml: 1, width: 32, height: 32, fontSize: 14, fontWeight: 700 }}>
          A
        </Avatar>

        <IconButton onClick={logout} aria-label="Çıkış yap" sx={{ ml: 0.5 }}>
          <LogoutIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
